import { AddExpenseFormModalContextProvider, AddRentChargeFormModalContextProvider, UpdateContractFormModalContextProvider } from "@/contexts"
import { ContractDetailExpensesList, ContractDetailIncidentList, ContractDetailNotesList, ContractDetailOverview, ContractDetailRentChargesList } from "../organism"
import { AddExpenseFormModal } from "./AddExpenseFormModal"

type ContractDetailTemplateProps = {
  selectedSection: string
}

export const ContractDetailTemplate = ({ selectedSection }: ContractDetailTemplateProps) => {
  return (
    <>
      {
        (
          () => {
            switch(selectedSection) {
              case '1':
                return (
                  <UpdateContractFormModalContextProvider>
                    <ContractDetailOverview />
                  </UpdateContractFormModalContextProvider>
                )
              
              case '2':
                return <p>Soy seccion 2</p>

              case '3':
                return <p>Soy seccion 3</p>

              case '4':
                return (
                  <AddRentChargeFormModalContextProvider>
                    <ContractDetailRentChargesList />
                  </AddRentChargeFormModalContextProvider>
                )

              case '5':
                return (
                  <AddExpenseFormModalContextProvider>
                    <ContractDetailExpensesList />
                    <AddExpenseFormModal />
                  </AddExpenseFormModalContextProvider>
                )

              case '6':
                return <p>Soy seccion 6</p>

              case '7':
                return <ContractDetailNotesList />

              case '8':
                return <ContractDetailIncidentList />

              default:
                console.warn('invalid option Contract tab option')
            }
          }
        )()
      }
    </>
  )
}